import React, { useState } from 'react';
import { Grid, TextField, Button, Box, Checkbox, Table, TableBody, TableCell, TableHead, TableRow, Paper } from '@mui/material';
import API_BASE_URL from '../../../../Constants';

const InvoiceFinanceCharges = () => {
  const [formData, setFormData] = useState({
    financeChargeId: '',
    user: '',
    date: new Date().toLocaleDateString('en-US'), // Set default date
    invoiceDate: '',
    percentCharged: '',
    daysOverDue: '',
    billingClass: '',
    accountStatus: '',
    comments: '',
    numOfInvoices: '',
    totalCharges: '',
    invoicesCreated: '',
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
        // Post the form data to the backend
        const response = await fetch(`${API_BASE_URL}/api/admin/financeCharges`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(formData),
        });

        if (!response.ok) {
            throw new Error('Error submitting form data');
        }

        const data = await response.json();
        console.log('Response:', data);
    } catch (error) {
        console.error('Error:', error);
    }
};


  return (
    <div className="container mx-auto p-4 bg-white h-screen">
      <form className="bg-white p-4 rounded-lg shadow-lg border" onSubmit={handleSubmit}>
        {/* Finance Charge ID Field and Buttons */}
        <Grid container alignItems="center" spacing={2} mb={4}>
          <Grid item xs={3}>
            <label className="text-sm font-bold text-gray-700">Finance Charge ID</label>
          </Grid>
          <Grid item xs={4}>
            <TextField
              fullWidth
              name="financeChargeId"
              value={formData.financeChargeId}
              onChange={handleInputChange}
              variant="outlined"
              size="small"
            />
          </Grid>
          <Grid item>
            <Button variant="contained" color="primary" type="submit">
              Calculate
            </Button>
          </Grid>
          <Grid item>
            <Button variant="contained" color="primary" type="submit">
              Create Invoices
            </Button>
          </Grid>
          <Grid item>
            <Button variant="contained" color="primary">
              Delete
            </Button>
          </Grid>
        </Grid>

        {/* Main form section with two columns and the image box */}
        <Grid container spacing={2}>
          {/* Left column */}
          <Grid item xs={4}>
            <Grid container spacing={0}>
              {/* Fields */}
              <Grid item xs={4}>
                <label className="text-sm font-bold text-gray-700">User</label>
              </Grid>
              <Grid item xs={8}>
                <TextField
                  fullWidth
                  name="user"
                  value={formData.user}
                  onChange={handleInputChange}
                  variant="outlined"
                  size="small"
                  style={{ width: '40%' }}
                />
              </Grid>
              <Grid item xs={4}>
                <label className="text-sm font-bold text-gray-700">Date</label>
              </Grid>
              <Grid item xs={8}>
                <TextField
                  fullWidth
                  name="date"
                  value={formData.date} 
                  variant="outlined"
                  size="small"
                  style={{ width: '40%', backgroundColor: '#f0f0f0' }}  
                  InputProps={{
                    readOnly: true,  
                  }}
                />
              </Grid>
              <Grid item xs={4}>
                <label className="text-sm font-bold text-gray-700">Invoice Date</label>
              </Grid>
              <Grid item xs={8}>
                <TextField
                  fullWidth
                  type="date"
                  name="invoiceDate"
                  value={formData.invoiceDate}
                  onChange={handleInputChange}
                  variant="outlined"
                  size="small"
                  style={{ width: '40%' }}
                />
              </Grid>
              <Grid item xs={4}>
                <label className="text-sm font-bold text-gray-700">Percent Charged</label>
              </Grid>
              <Grid item xs={8}>
                <TextField
                  fullWidth
                  name="percentCharged"
                  value={formData.percentCharged}
                  onChange={handleInputChange}
                  variant="outlined"
                  size="small"
                  style={{ width: '40%' }}
                />
              </Grid>
              <Grid item xs={4}>
                <label className="text-sm font-bold text-gray-700">Days Over Due</label>
              </Grid>
              <Grid item xs={8}>
                <TextField
                  fullWidth
                  name="daysOverDue"
                  value={formData.daysOverDue}
                  onChange={handleInputChange}
                  variant="outlined"
                  size="small"
                  style={{ width: '40%' }}
                />
              </Grid>
              <Grid item xs={4}>
                <label className="text-sm font-bold text-gray-700">Billing Class</label>
              </Grid>
              <Grid item xs={8}>
                <TextField
                  fullWidth
                  name="billingClass"
                  value={formData.billingClass}
                  onChange={handleInputChange}
                  variant="outlined"
                  size="small"
                  style={{ width: '50%' }}
                />
              </Grid>
              <Grid item xs={4}>
                <label className="text-sm font-bold text-gray-700">Account Status</label>
              </Grid>
              <Grid item xs={8}>
                <TextField
                  fullWidth
                  name="accountStatus"
                  value={formData.accountStatus}
                  onChange={handleInputChange}
                  variant="outlined"
                  size="small"
                  style={{ width: '50%' }}
                />
              </Grid>
              <Grid item xs={4}>
                <label className="text-sm font-bold text-gray-700">Comments</label>
              </Grid>
              <Grid item xs={8}>
                <TextField
                  fullWidth
                  multiline
                  rows={1}
                  name="comments"
                  value={formData.comments}
                  onChange={handleInputChange}
                  variant="outlined"
                  size="small"
                  style={{ width: '250%' }}
                />
              </Grid>
            </Grid>
          </Grid>

          {/* Right column */}
          <Grid item xs={4}>
            <Grid container spacing={0}>
              <Grid item xs={4}>
                <label className="text-sm font-bold text-gray-700"># of Invoices</label>
              </Grid>
              <Grid item xs={8}>
                <TextField
                  fullWidth
                  name="numOfInvoices"
                  value={formData.numOfInvoices}
                  onChange={handleInputChange}
                  variant="outlined"
                  size="small"
                  style={{ width: '40%' }}
                />
              </Grid>
              <Grid item xs={4}>
                <label className="text-sm font-bold text-gray-700">Total Charges</label>
              </Grid>
              <Grid item xs={8}>
                <TextField
                  fullWidth
                  name="totalCharges"
                  value={formData.totalCharges}
                  onChange={handleInputChange}
                  variant="outlined"
                  size="small"
                  style={{ width: '40%' }}
                />
              </Grid>
              <Grid item xs={4}>
                <label className="text-sm font-bold text-gray-700">Invoices Created</label>
              </Grid>
              <Grid item xs={8}>
                <TextField
                  fullWidth
                  name="invoicesCreated"
                  value={formData.invoicesCreated}
                  onChange={handleInputChange}
                  variant="outlined"
                  size="small"
                  style={{ width: '40%' }}
                />
              </Grid>
            </Grid>
          </Grid>

          {/* Image box (third column) */}
          <Grid item xs={4}>
            <Box
              sx={{
                border: '1px solid gray',
                width: '100%',
                height: '100%',
                backgroundColor: '#f0f0f0',
              }}
            >
              {/* Placeholder for image */}
            </Box>
          </Grid>
        </Grid>

        {/* Bottom checkboxes container */}
        <Paper elevation={3} style={{ padding: '10px', marginTop: '20px' }}>
          <Box
            sx={{
              border: '1px solid gray',
              padding: '10px',
              backgroundColor: 'white',
            }}
          >
            <Grid container spacing={1}>
              <Grid item xs={12} style={{ backgroundColor: '#f0f0f0', padding: '10px' }}>
                <span style={{ fontWeight: 'bold' }}>Include</span>
              </Grid>
              <Grid item xs={12}>
                <Grid container spacing={1} justifyContent="space-around">
                  <Grid item>
                    <Checkbox /> Maintenance
                  </Grid>
                  <Grid item>
                    <Checkbox /> Service
                  </Grid>
                  <Grid item>
                    <Checkbox /> Repair
                  </Grid>
                  <Grid item>
                    <Checkbox /> Mod/Construction
                  </Grid>
                  <Grid item>
                    <Checkbox /> Inspection
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Box>
        </Paper>

        {/* Bottom table container */}
        <Paper elevation={3} style={{ padding: '20px', marginTop: '20px' }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell style={{ backgroundColor: '#f0f0f0', fontWeight: 'bold' }}>Invoice #</TableCell>
                <TableCell style={{ backgroundColor: '#f0f0f0', fontWeight: 'bold' }}>Open Balance</TableCell>
                <TableCell style={{ backgroundColor: '#f0f0f0', fontWeight: 'bold' }}>Finance Chg</TableCell>
                <TableCell style={{ backgroundColor: '#f0f0f0', fontWeight: 'bold' }}>Building Reference</TableCell>
                <TableCell style={{ backgroundColor: '#f0f0f0', fontWeight: 'bold' }}>Customer Number</TableCell>
                <TableCell style={{ backgroundColor: '#f0f0f0', fontWeight: 'bold' }}>Fin Chg Invoice #</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell>-</TableCell>
                <TableCell>-</TableCell>
                <TableCell>-</TableCell>
                <TableCell>-</TableCell>
                <TableCell>-</TableCell>
                <TableCell>-</TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </Paper>
      </form>
    </div>
  );
};

export default InvoiceFinanceCharges;